import { Box, Button, Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import { useFieldArray, useForm } from "react-hook-form";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSelectField from "../../Components/Select/WSSelect";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import { useNavigate } from "react-router-dom";

export const Purchase: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const [isRoundOffChecked, setIsRoundOffChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const { fields, append, remove, replace } = useFieldArray({
    name: "items",
    control,
  });
  const [showExtraFields, setShowExtraFields] = useState(false);
const genId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);
const [paymentRows, setPaymentRows] = useState(() => [{ id: genId(), paymentType: '', amount: '' }]);

const handleAddRow = () => setPaymentRows(prev => [...prev, { id: genId(), paymentType: '', amount: '' }]);
const handleRemoveRow = (idToRemove:any) => setPaymentRows(prev => prev.filter(r => r.id !== idToRemove));



  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleDataSaveAndNew = () => {};

   const handleClose = () => {
    navigate("/");
  };
  return (
    <>
      <Grid p={3}>
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 0,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={11}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                {" "}
                Purchase
              </Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
                  <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSAutocompleteField
                rules={{ required: true }}
                {...register("party")}
                id="party"
                control={control}
                label="Party"
                name="party"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSPhone
                label={"Phone Number"}
                id={"phoneNumber"}
                name={"phoneNumber"}
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Bill No"}
                {...register("billNo")}
                id="billNo"
                name="billNo"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="billDate"
                name="billDate"
                label={"Bill Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>

            {fields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                <Grid item xs={12} sm={2}>
                  <WSSelectField
                    label="Category"
                    rules={{ required: true }}
                    {...register(`items.${index}.Category`)}
                    id={`Category-${index}`}
                    control={control}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="Item"
                    {...register(`items.${index}.item`)}
                    id={`item-${index}`}
                    control={control}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="Item Code"
                    {...register(`items.${index}.itemCode`, {})}
                    id={`itemCode-${index}`}
                    control={control}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="HSN Code"
                    id={`hsnCode-${index}`}
                    {...register(`items.${index}.hsnCode`, {})}
                    control={control}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="Description"
                    id={`description-${index}`}
                    {...register(`items.${index}.description`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="QTY"
                    id={`qty-${index}`}
                    {...register(`items.${index}.qty`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <WSSelectField
                    label="Unit"
                    rules={{ required: true }}
                    {...register(`items.${index}.unit`)}
                    id={`unit-${index}`}
                    control={control}
                  />
                </Grid>

                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Price/Unit"
                    id={`price-${index}`}
                    {...register(`items.${index}.price`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Discount"
                    id={`discount-${index}`}
                    {...register(`items.${index}.discount`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Tax"
                    id={`tax-${index}`}
                    {...register(`items.${index}.tax`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Amount"
                    id={`amount-${index}`}
                    {...register(`items.${index}.amount`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => {
                      remove(index);
                    }}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ Add"
                size="small"
                onClick={() =>
                  append({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
      {!showExtraFields ? (
        <>
          <WSSelectField
            label="Payment Type"
            rules={{ required: true }}
            {...register("paymentType")}
            id={"paymentType"}
            control={control}
          />
          <Button
            variant="text"
            size="small"
            sx={{ textTransform: "none", p: 0, mt: 1 }}
            onClick={() => setShowExtraFields(true)}
          >
            + Add Payment Details
          </Button>
        </>
      ) : (
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2}>
          {paymentRows.map((row, index) => (
  <React.Fragment key={row.id}>
    <Grid item xs={12} sm={4}>
      <WSSelectField
        label="Payment Type"
        {...register(`paymentRows.${index}.paymentType`)}
        id={`paymentType-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSTextField
        label="Amount"
        {...register(`paymentRows.${index}.amount`)}
        id={`amount-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSIcons.DeleteIcon onClick={() => handleRemoveRow(row.id)} sx={{ cursor: 'pointer' }} />
    </Grid>
  </React.Fragment>
))}

            <Grid item xs={12}>
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", p: 0, mt: 1 }}
                onClick={handleAddRow}
              >
                + Add Payment Type
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}
    </Grid>
            <Grid item xs={12} sm={2}>
              <WSSCheckBoxField
                label="Round Off"
                id="roundOff"
                control={control}
                {...register("roundOff")}
                rules={{ required: false }}
                name="roundOff"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setIsRoundOffChecked(e.target.checked)
                }
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <WSTextField
                label=""
                {...register("round")}
                id="round"
                name="round"
                control={control}
                rules={{ required: false }}
                disabled={!isRoundOffChecked} // Disable if not checked
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <WSTextField
                label={"Total"}
                {...register("total")}
                id="total"
                name="total"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12}>
           <WSFileUpload
                  name="uploadBill"
                  label="Upload Bill"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png"
                  maxFileSizeMB={2}
                  //  defaultValue={defaultImg}
                  id={"uploadBill"}
                  image={true}
                  align="Start"
                  isToolTipImg={false}
                  multiple={true}
                />
          </Grid>
          </Grid>
        </Paper>
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save & New"
              size="medium"
              variant="outlined"
              color="primary"
              onClick={handleSubmit(handleDataSaveAndNew)}
              loading={loadingSaveAndNew}
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "rgba(126, 176, 246, 1)",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 2,
                width: "6rem",
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
